
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from '../../shared';

@Component({
  selector: 'app-form-i',
  templateUrl: './app-form-i.component.html',
})
export class AppFormIComponent implements OnInit {
  public formName = 'rubrique_I_preemption';
  public formIsValid = true;

  form: FormGroup;
  items: FormArray;

  constructor(
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService
  ) {}

  get formData() { return <FormArray>this.form.get('items'); }

  ngOnInit (): void {
    this.form = new FormGroup({
      i_decision: new FormControl('', Validators.required),
    });

    this.form = this.formBuilder.group({
      items: this.formBuilder.array([ this.createItem() ])
    });

    this.restoreFromStorage();

    // Auto-sauvegarder le brouillon du formulaire pendant la saisie
    this.form.valueChanges.subscribe(() => this.saveToStorage());
  }

  /**
   * Affiche le message et active la classe d'invalidité pour les champs requis
   *
   * @param dirty
   * @param {string} type
   * @param {string} fieldType
   * @returns {any}
   */
  checkFieldValidity(dirty, type = 'validity', fieldType = 'input'): any {
    const valid = this.formIsValid;

    switch (type) {
      case 'class':
        if (!valid && !dirty) {
          if (fieldType === 'input') {
            return 'is-invalid';
          } else {
            return 'label-is-invalid';
          }
        } else {
          return '';
        }
      default:
        if (!valid && !dirty) {
          return true;
        } else {
          return false;
        }
    }
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      i_decision: '',
    });
  }

  /**
   * Sauvegarde le brouillon dans le localStorage.
   */
  private saveToStorage(): void {
    this.localStorageService.save('form_i', {
      values: this.formData.at(0).value
    });
  }

  /**
   * Restaure le brouillon depuis le localStorage.
   */
  private restoreFromStorage(): void {
    const saved = this.localStorageService.load('form_i');
    if (!saved) { return; }
    if (saved.values) {
      this.formData.at(0).patchValue(saved.values, { emitEvent: false });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-i/app-form-i.component.ts